<template>
  <page-header></page-header>

  <div class="innerPageBanner partnerBanner">
    <div class="container-sm">
      <div class="row">
        <div class="col-md-12">
          <div class="innerBannerText">
            <h1>COPYRIGHT</h1>
            <p style="text-align: justify">
              DISCLAIMER: © Postmedia Network Canada Corp. 2010-2021. All rights
              reserved.<br />
              This website is the property of Postmedia Network Canada Corp.
              (“Postmedia”). All information and content or other material
              (collectively, “Content”) found in the pages of this web site is
              protected under the copyright laws of Canada and other countries.
              Unless otherwise specified, no person has permission to copy,
              redistribute, reproduce or republish in any form any Content found
              on the pages in this web site. This includes electronically
              reproducing by “uploading” or “downloading” or otherwise
              transmitting onto the Internet or any other local or international
              computer system. Any infringement of the rights of Postmedia may
              result in appropriate legal action.<br />
              If you require further information on a permitted use or license
              to reproduce or republishing any Content, kindly address your
              inquiry to webmaster@postmedia.com. Postmedia disclaims any and
              all liability for any consequences whatsoever which may result
              from any unauthorized reproduction or use of the Content of this
              web site.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Track Parcel page Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="p-4 fs-3">
            Proof of Delivery, review the delivery image
          </div>
        </div>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "./PageFooter.vue";
import PageHeader from "./PageHeader.vue";

export default {
  beforeMount() {
    scroll(0, 0);
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
};
</script>
